import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { LifecycleComponent } from '../lifecycle-component';
import { BootService } from './services/boot';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends LifecycleComponent implements OnInit {
  private readonly bootService = inject(BootService);

  ngOnInit(): void {
    this.bootService.boot({});
  }
}
